module.exports = "<p class=\"header\">\r\n  {{'jackpot.header' | translate}}\r\n</p>\r\n<p class=\"value\">\r\n  {{sessionService.jackpotWonAmount | number: '1.2-2'}}\r\n</p>\r\n<p class=\"claim\" (click)=\"sessionService.showJackpotWon = false\">\r\n  {{'jackpot.claim' | translate}}\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/jackpot-bubble/jackpot-bubble.component.html
// module id = ../../../../../src/app/jackpot-bubble/jackpot-bubble.component.html
// module chunks = 1